/**
 * TruDiagnosticAdmin.tsx — Admin → Integrations → TruDiagnostic.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function TruDiagnosticAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="trudiagnostic"
      title="TruDiagnostic"
      subtitle="At-home epigenetic / biological-age tests (TruAge, TruHealth) via the TruDiagnostic API"
      vendorName="TruDiagnostic"
    />
  );
}
